import { useAlertWebhookSender } from '@/hooks/useAlertWebhook';

export function AlertWebhookProvider({ children }: { children: React.ReactNode }) {
  // Always call the hook - it will handle auth state internally
  useAlertWebhookSender();
  
  return <>{children}</>;
} 